export default __webpack_public_path__ + "static/media/bday4.a1ba9982.jpg";